"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import { useList } from '../../hooks/useList.mjs';
import 'react';
import { Render } from '../../../../lib/react/components/Render/Render.mjs';

const DataLoader = () => {
  const loaderHooks = useList().loader.getLoaderInvocationHooks();
  return loaderHooks.map((useLoadData, i) => /* @__PURE__ */ jsx(Render, { children: () => {
    useLoadData();
  } }, i));
};

export { DataLoader, DataLoader as default };
//# sourceMappingURL=DataLoader.mjs.map
